export const scheduleMethod = (value: string): string => {
    return value === 'Online' ? 'Online' : 'Face to Face';
}
